import vert from '!raw-loader!./vertex.glsl';
import frag from '!raw-loader!./fragment.glsl';

function loadTexture(gl, oc) {
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, oc); // This is the important line!
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.bindTexture(gl.TEXTURE_2D, null);
    return texture;
}

function setArrays(gl, prog) {
    let vertex_buffer = gl.createBuffer();
    const vertices = [-1.0, -1.0, 1.0, -1.0, -1.0, 1.0,
        1.0, 1.0, 1.0, -1.0, -1.0, 1.0,
    ];
    gl.bindBuffer(gl.ARRAY_BUFFER, vertex_buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
    let coord = gl.getAttribLocation(prog, "coords");
    gl.vertexAttribPointer(coord, 2, gl.FLOAT, false, 0, 0);
    gl.enableVertexAttribArray(coord);
    return [coord, vertex_buffer];
}

function prepareWebGL(gl, width, height) {
    let vertSh = gl.createShader(gl.VERTEX_SHADER);
    gl.shaderSource(vertSh, vert);
    gl.compileShader(vertSh);
    let fragSh = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(fragSh, frag);
    gl.compileShader(fragSh);
    let prog = gl.createProgram();
    gl.attachShader(prog, vertSh);
    gl.attachShader(prog, fragSh);
    gl.linkProgram(prog);
    gl.useProgram(prog);
    gl.viewport(0,0, width, height);
    return prog;
}

function enhance_layers(canvas) {
    if ( typeof enhance_layers.webglCanvas == 'undefined' ) {
        enhance_layers.webglCanvas = document.createElement('canvas');
        let wgl_canvas = enhance_layers.webglCanvas;
        wgl_canvas.width = canvas.width;
        wgl_canvas.height = canvas.height;
        enhance_layers.gl = wgl_canvas.getContext("webgl");
        enhance_layers.prog = prepareWebGL(enhance_layers.gl, wgl_canvas.width, wgl_canvas.height);
        setArrays(enhance_layers.gl, enhance_layers.prog);
        const uSampler = enhance_layers.gl.getUniformLocation(enhance_layers.prog, 'uSampler');
        enhance_layers.gl.uniform1i(uSampler, 0);
    }

    let gl = enhance_layers.gl;
    const texture = loadTexture(gl, canvas);
    let ctx = canvas.getContext('2d');
    let wgl = enhance_layers.webglCanvas;

    let render = (it, tx) => {
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, tx);
        gl.clearColor(0.0, 0.0, 0.0, 1.0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
        ctx.drawImage(wgl, 0, 0, wgl.width, wgl.height, 0, 0, canvas.width, canvas.height);
    };

    render(0, texture);
}

export default function enhanceCanvas(canvasElement) {
    enhance_layers(canvasElement);
}
